import React from 'react';
import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';
import { UserInteractionServiceV1 } from '@volkswagen-onehub/user-interaction-service';
import { actionRedirect } from '../../../../helpers/common-helpers';

export const longdriveStandardLayer = (userInteractionService: UserInteractionServiceV1): ServiceLayer => ({
	header: 'Coberturas',
	title: 'Volkswagen Long Drive Standard',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Con tu suscripción de mantenimiento, lo tienes todo incluido en una única cuota mensual. Será mucho más cómodo,
			porque siempre podrás pasar por el taller sin preocuparte por cuánto te costará. Y sin entrada ni comisiones.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0130}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				¿Qué incluye tu plan Standard?
			</Text>
			<Container wrap="always" gutter={ContainerGutter.dynamic0020}>
				<Container wrap="always" padding={{ bottom: ContainerPadding.dynamic0050 }}>
					<Text appearance={TokenTextAppearance.copy200} bold>
						Mantenimiento
					</Text>
					<Container wrap="always" padding={{ left: ContainerPadding.dynamic0050 }}>
						<Text appearance={TokenTextAppearance.copy200}>
							<List gutter={ListGutter.static0}>
								<ListItem>{'Servicio de mantenimiento con cambio de aceite (flexible).'}</ListItem>
								<ListItem>Inspección técnica.</ListItem>
								<ListItem>Sustitución de las bujías.</ListItem>
								<ListItem>Sustitución del filtro de polen, del filtro de gasoil y del filtro de aire.</ListItem>
								<ListItem>
									{'Sustitución del aceite y del filtro de la caja de cambios automática (si aplica).'}
								</ListItem>
								<ListItem>Sustitución del aceite Haldex.</ListItem>
								<ListItem>Servicio de sustitución del líquido de frenos.</ListItem>
								<ListItem>Revisión de los gases de escape.</ListItem>
								<ListItem>Ajuste de los faros.</ListItem>
								<ListItem>Limpieza de los frenos del tambor trasero.</ListItem>
								<ListItem>Check del enganche del remolque.</ListItem>
								<ListItem>Servicio de reposición del líquido del parabrisas.</ListItem>
								<ListItem>Engrasar el techo.</ListItem>
							</List>
						</Text>
					</Container>
				</Container>

				<Container wrap="always" padding={{ bottom: ContainerPadding.dynamic0050 }}>
					<Text appearance={TokenTextAppearance.copy200} bold>
						Asistencia en carretera
					</Text>
					<Container wrap="always" padding={{ left: ContainerPadding.dynamic0050 }}>
						<Text appearance={TokenTextAppearance.copy200}>
							<List gutter={ListGutter.static0}>
								<ListItem>
									Servicio en vigor durante el periodo de contratación de Volkswagen Long Drive y con un máximo de hasta
									10 años.
								</ListItem>
								<ListItem>Disponible las 24 horas del día y los 365 días del año.</ListItem>
								<ListItem>Asistencia válida en toda Europa y países ribereños del Mediterráneo.</ListItem>
								<ListItem>Asistencia proporcionada a la persona y al vehículo.</ListItem>
								<ListItem>
									Consulta las condiciones específicas del servicio en{' '}
									<CTA
										tag="a"
										emphasis="tertiary"
										href="https://www.volkswagen.es/es/clientes/beneficios-volkswagen/servicios-movilidad/asistencia-accidentes-averias.html"
										aria-label="Volkwagen Asistencia."
										target="_blank"
									>
										<Text color={TokenTextColor.primary}>Volkswagen Asistencia</Text>
									</CTA>
									.
								</ListItem>
							</List>
						</Text>
					</Container>
				</Container>

				<Container wrap="always" padding={{ bottom: ContainerPadding.dynamic0050 }}>
					<Text appearance={TokenTextAppearance.copy200} bold>
						Coche de sustitución
					</Text>
					<Container wrap="always" padding={{ left: ContainerPadding.dynamic0050 }}>
						<Text appearance={TokenTextAppearance.copy200}>
							<List gutter={ListGutter.static0}>
								<ListItem>
									Posibilidad de disponer de un coche de sustitución de manera gratuita con un límite de días para
									ciertas operaciones en taller.
								</ListItem>
								<ListItem>
									Consulta con tu Servicio Oficial las características, condiciones y disponibilidad específicas de este
									servicio.
								</ListItem>
							</List>
						</Text>
					</Container>
				</Container>
			</Container>
		</Container>
	),
	descriptionFooter: (
		<Container wrap="always" gutter={ContainerGutter.static300}>
			<Text appearance={TokenTextAppearance.copy200}>
				Además, tu plan de mantenimiento Standard incluye asistencia en carretera 24/7 y coche de sustitución en caso de
				avería.
			</Text>
			<Container wrap="always">
				<Text appearance={TokenTextAppearance.copy200}>
					¿Quieres incluir el cambio de piezas por desgaste a tu plan?{' '}
					<CTA
						tag="a"
						emphasis="tertiary"
						onClick={() => {
							actionRedirect(userInteractionService, 'action:es-cca-loader--open_layer');
						}}
						aria-label="Pásate a Long Drive Advance"
						target="_blank"
					>
						<Text color={TokenTextColor.primary}>Pide cita en tu concesionario</Text>
					</CTA>{' '}
					para pasarte a Long Drive Advance.
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					Quieres incluir el cambio de piezas por desgaste y también los neumáticos?{' '}
					<CTA
						tag="a"
						emphasis="tertiary"
						onClick={() => {
							actionRedirect(userInteractionService, 'action:es-cca-loader--open_layer');
						}}
						aria-label="pásate a Long Drive Pro"
						target="_blank"
					>
						<Text color={TokenTextColor.primary}>Pide cita en tu concesionario </Text>
					</CTA>{' '}
					para pasarte a Long Drive Pro
				</Text>
			</Container>
		</Container>
	),
	imageFooter:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-long-drive-horizontal?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT01NDAmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMmFiZg==',
});
